import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'

import { transactionsSelector } from '@/state/transactions/slices/index.slices'
import { useContributionsActions } from './use-contributions-actions.hook'
import { ContributionsFilters } from '@/state/transactions/models'

export const useContributionsFilters = () => {
  const { getAllFreePlayContributions, setContributionsFilters } =
    useContributionsActions()

  const { contributionsFilters, pagination } = useSelector(transactionsSelector)

  // eslint-disable-next-line
  const filterDelay = useCallback(
    debounce((newFilters: Partial<ContributionsFilters>) => {
      getAllFreePlayContributions(newFilters)
    }, 500),
    [],
  )

  const handleChangeSearch = (
    newFilter: Partial<ContributionsFilters>,
    debounce?: boolean,
  ) => {
    const newFilters = {
      ...contributionsFilters,
      ...newFilter,
      page: 1,
    }

    setContributionsFilters(newFilters)

    if (debounce) {
      filterDelay(newFilters)
    } else {
      getAllFreePlayContributions(newFilters)
    }
  }

  const handleChangePage = (newPage: number) => {
    setContributionsFilters({ ...contributionsFilters, page: newPage })
    getAllFreePlayContributions({ ...contributionsFilters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (
      Math.ceil(pagination.total / newLimit) < (contributionsFilters.page || 1)
    ) {
      setContributionsFilters({
        ...contributionsFilters,
        limit: newLimit,
        page: 1,
      })
      getAllFreePlayContributions({
        ...contributionsFilters,
        limit: newLimit,
        page: 1,
      })
    } else {
      setContributionsFilters({ ...contributionsFilters, limit: newLimit })
      getAllFreePlayContributions({ ...contributionsFilters, limit: newLimit })
    }
  }

  const submitSearchFilter = () => {
    getAllFreePlayContributions(contributionsFilters)
  }

  return {
    contributionsFilters,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
    submitSearchFilter,
  }
}
